import React from 'react';
import PermissionRoute from './PermissionRoute';

/**
 * Higher-Order Component for wrapping components with permission checking
 * @param Component - The component to wrap
 * @param requiredPermission - The permission module name to check (e.g., 'edit-user', 'view-reports')
 * @returns Wrapped component with permission route
 * 
 * Usage: withPermissionRoute(EditUser, 'edit-user')
 */
export const withPermissionRoute = (
  Component: React.ComponentType<any>,
  requiredPermission?: string
): React.ComponentType<any> => {
  return (props: any): React.JSX.Element => (
    <PermissionRoute requiredPermission={requiredPermission}>
      <Component {...props} />
    </PermissionRoute>
  );
};
